module.exports = __webpack_public_path__ + "static/img/detail_pic1.8453cf3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/detail_pic1.png
// module id = m4It
// module chunks = 15